(() => {
  angular
    .module('gm.common.directives')
    .directive('gmIdUpload', gmIdUploadDirective);

  function gmIdUploadDirective(
    $rootScope,
    GmyVerification,
    btgUser
  ) {
    'ngInject';

    return {
      controllerAs: 'ctrl',
      require: 'ngModel',
      restrict: 'E',
      scope: {
        allowedIdTypes: '=',
        skipValidation: '=?'
      },
      templateUrl: 'modules/common/directives/id-upload/id-upload.html',

      link(scope, _element, _attrs, ctrl) {
        scope.$sc = scope;
        const ID_TYPES = GmyVerification.ID_TYPES;

        scope.document = null;
        scope.isExpirationDateRequired = false;
        scope.uploadPercent = 0;
        scope.isImageConfirmed = false;

        scope.idFormData = {
          type: null,
          expirationDate: '',
          idNumber: ''
        };

        const ALL_ID_TYPES = [
          { id: ID_TYPES.PASSPORT, name: 'Passport' },
          { id: ID_TYPES.LICENSE, name: 'Licence' },
          { id: ID_TYPES.NATIONAL, name: 'National' },
          { id: ID_TYPES.Form147C, name: 'Form 147C' },
          { id: ID_TYPES.FormSS4, name: 'Form SS4' }
        ];

        const BASIC_ID_TYPES = [
          { id: ID_TYPES.PASSPORT, name: 'Passport' },
          { id: ID_TYPES.LICENSE, name: 'Licence' },
          { id: ID_TYPES.NATIONAL, name: 'National' }
        ];

        if (scope.allowedIdTypes) {
          scope.idTypeList = ALL_ID_TYPES.filter(
            type => scope.allowedIdTypes.indexOf(type.id) !== -1
          );
          scope.countryCode = btgUser.getProfile().countryCode;
        } else {
          scope.idTypeList = BASIC_ID_TYPES;
        }

        function processErrors() {
          scope.idForm.$setValidity('server', false);
        }

        function resetErrors() {
          scope.idForm.$setValidity('server', true);
        }

        scope.$watch('idFormData.type', (type) => {
          scope.isExpirationDateRequired = [ID_TYPES.PASSPORT, ID_TYPES.LICENSE].indexOf(type) > -1;
        });

        scope.$on('modal:webcamPhoto:picture', (_event, data) => {
          scope.document = data;
          scope.$emit('modal:webcamPhoto:close');
        });

        scope.allowsPassport = () => scope.allowedIdTypes.indexOf(ID_TYPES.PASSPORT) !== -1;
        scope.allowsID = () => scope.allowedIdTypes.indexOf(ID_TYPES.NATIONAL) !== -1;
        scope.allowsLicense = () => scope.allowedIdTypes.indexOf(ID_TYPES.LICENSE) !== -1;

        scope.allowsForms = () => {
          if (!scope.allowedIdTypes) {
            return false;
          }

          return scope.allowedIdTypes.indexOf(ID_TYPES.FormSS4) !== -1;
        };

        scope.approveImage = () => {
          scope.isImageConfirmed = true;
        };

        scope.rejectImage = () => {
          scope.document = null;
        };

        scope.submitForm = () => {
          resetErrors();

          if (scope.idForm.$valid) {
            let code;
            const formData = scope.idFormData;

            const data = {
              type: formData.type,
              number: formData.idNumber,
              expiration: formData.expirationDate ? formData.expirationDate : null
            };

            return GmyVerification
              .generateUploadIdCode(data)
              .then((generateCode) => {
                code = generateCode;

                return GmyVerification
                  .uploadId(scope.document, code)
                  .then(null, null, (respData) => {
                    scope.uploadPercent = Math.round((respData.loaded * 100) / respData.total);
                  });
              })
              .then(() => { // @note: should this action run in parallel?
                if (!scope.skipValidation) {
                  return GmyVerification.confirmDocumentUpload(code);
                }

                return false;
              })
              .then(() => {
                ctrl.$setViewValue(true);
                scope.$emit('gm:document:uploaded');
                $rootScope.$emit('gm:document:uploaded');
              })
              .catch(processErrors)
              .finally(() => { scope.uploadPercent = 0; });
          }

          return false;
        };

        scope.takePhoto = () => {
          scope.$emit('modal:webcamPhoto:open');
        };
      },
    };
  }
})();
